import { takeEvery, call, fork, put, takeLatest } from 'redux-saga/effects';
import { FIND_ITINERARIES, findItinerariesSucess, findItinerariesFail, getItinerariesNetworkFail, getItinerariesNetworkSuccess, GET_ITINERARIES_NETWORK, showAlert, FIND_ALL_ROUTES, findAllRoutesFail, findAllRoutesSucess, missingToken, GET_ROUTE_PRICE, getRoutePriceSuccess, getRoutePriceFail } from '../actions';
import { getUrlParameter, getItineraries, getItinerariesNetwork, getAllRoutes, getRoutePrice, getLang } from '../api';

function* handlerGetRoutePrice(action) {
    try {
        const { lang } = action.payload;
        const res = yield call(getRoutePrice, { lang });
        yield put(getRoutePriceSuccess(res.data));
    } catch(e) {
        yield put(getRoutePriceFail());
    }
}

function* handlerGetItineraries(action) {
    const token = getUrlParameter('token');

    // if (token === '') {
    //     yield put(missingToken());
    // }

    try{
        const { from, to } = action.payload;

        if (from === '' || to === '' || from === undefined || to === undefined) {
            yield put(showAlert('select_d_and_a'));
            return;
        }

        const lang = getLang();
        const res = yield call(getItineraries, { token, from, to, lang });
        yield put(findItinerariesSucess(res.data, from, to));
    } catch(e) {
        // console.log(e.response.data, e.response.status);
        if (e.response && e.response.status === 404) {
            yield put(showAlert('no_flight'));
        }

        yield put(findItinerariesFail('An error occurred when trying to get route'));
    }
}

function* handlerGetAllRoutes(action) {
    const token = getUrlParameter('token');

    // if (token === '') {
    //     yield put(missingToken());
    // }

    try{
        const res = yield call(getAllRoutes, { token, from: action.payload.fromCode });
        yield put(findAllRoutesSucess(res.data));
    }catch(e) {
        if (e.response && e.response.status === 404) {
            yield put(showAlert('no_network_flight'));
        }

        yield put(findAllRoutesFail('An error occurred when trying to get route'));
    }
}

function* handlerGetItinerariesNetwork(action) {
    const token = getUrlParameter('token');

    // if (token === '') {
    //     yield put(missingToken());
    // }

    const { codeshareChecked } = action.payload.filters;

    try{
        const res = yield call(getItinerariesNetwork, { token, codeshareChecked });
        yield put(getItinerariesNetworkSuccess(res.data));
    }catch(e) {
        if (e.response && e.response.status === 404) {
            yield put(showAlert('no_network_flight'));
        }

        yield put(getItinerariesNetworkFail('An error occurred when trying to get data'));
    }
}

function* watchGetRoutePriceRequest() {
    yield takeLatest(GET_ROUTE_PRICE, handlerGetRoutePrice);
}

function* watchGetItinerariesRequest() {
    yield takeEvery(FIND_ITINERARIES, handlerGetItineraries);
}

function* watchGetItinerariesNetworkRequest() {
    yield takeEvery(GET_ITINERARIES_NETWORK, handlerGetItinerariesNetwork);
}

function* watchGetAllRoutesRequest() {
    yield takeEvery(FIND_ALL_ROUTES, handlerGetAllRoutes);
}

const itinerarySagas = [
    fork(watchGetItinerariesRequest),
    fork(watchGetItinerariesNetworkRequest),
    fork(watchGetAllRoutesRequest),
    fork(watchGetRoutePriceRequest)
];

export default itinerarySagas;